import { useEffect } from 'react';
import {
  tickRendererConnectivityTimeout,
  syncRendererConnectivityFromZones,
} from '../transport/rendererConnectivity';
import { useMaestroStore } from '../store/maestroStore';

/**
 * Periodically promotes reconnecting → unreachable and keeps connectivity in sync.
 */
export default function useRendererConnectivity() {
  const activeZoneId = useMaestroStore((s) => s.discovery?.activeZone?.id);
  const zoneCount = useMaestroStore((s) => s.discovery?.discoveredZones?.length ?? 0);

  useEffect(() => {
    syncRendererConnectivityFromZones();
  }, [activeZoneId, zoneCount]);

  useEffect(() => {
    const id = setInterval(() => {
      tickRendererConnectivityTimeout();
    }, 5000);
    return () => clearInterval(id);
  }, []);
}
